import "./spin-loading.css";
import { SpinLoading } from './spin-loading';
export default SpinLoading;